import {
  formatDateKey,
  formatInstantDate,
  formatInstantDateTime,
} from "@/shared/utils/dateKey";

export const getMaxDate = (maxYear: number) => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - -1 * maxYear);
  return today.toISOString().split("T")[0];
};

export const getMinDate = (minYear: number) => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - minYear);
  return today.toISOString().split("T")[0];
};

export const formatToDDMMYYYY = (isoDate: string) => {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatToISO = (ddmmyyyy: string) => {
  const [day, month, year] = ddmmyyyy.split("/");
  return `${year}-${month}-${day}`;
};

/** Business date (`YYYY-MM-DD` or UTC-midnight ISO) as `dd/mm/yyyy`. */
export const formatDate = (isoDate: string) => formatDateKey(isoDate);

/** Real timestamp as `dd/mm/yyyy`, in the business time zone (Caracas). */
export const formatTimestampDate = (isoDate: string) =>
  formatInstantDate(isoDate);

/** Real timestamp as `dd/mm/yyyy hh:mm AM/PM`, in the business time zone. */
export const formatDateTime = (isoDate: string) =>
  formatInstantDateTime(isoDate);
